// react components
import React from 'react'
import {
    Elements,
} from '@stripe/react-stripe-js'
import {
    useSelector,
} from 'react-redux'

// data
import {
    defaultReduxState,
} from 'data'

// pages
import {
    TemplateBlock783StripeSite,
} from 'pages'

// serializers
import {
    MainStyleSerializer,
    PortfolioPageContentListSiteSerializer,
    Template783SiteSerializer,
    formInfoTypeSite,
    formValueTypeSite,
} from 'serializers/site'

// props
type TemplateBlock783StripeWrapperSiteProps = {
    blockId: string
    content: Template783SiteSerializer | undefined
    contentArray: Template783SiteSerializer[] | undefined
    formInfo: formInfoTypeSite
    formValue: formValueTypeSite
    isEditHovered: boolean
    isInComponent?: boolean
    learnPageSlug?: string
    mainParentId?: number
    object: PortfolioPageContentListSiteSerializer
    pageSlug: string | undefined
    parentArray?: number[]
    parentStyles?: any
    setFormValue: React.Dispatch<formValueTypeSite> | undefined
    styles: MainStyleSerializer
    stylesEdit: MainStyleSerializer | undefined
}

// main
export const TemplateBlock783StripeWrapperSite: React.FC<TemplateBlock783StripeWrapperSiteProps> = React.memo(({
    blockId,
    content,
    contentArray,
    formInfo,
    formValue,
    isEditHovered,
    isInComponent,
    learnPageSlug,
    mainParentId,
    object,
    pageSlug,
    parentArray,
    parentStyles,
    setFormValue,
    styles,
    stylesEdit,
}) => {

    const reduxModalSite = useSelector((state: defaultReduxState) => state.reduxModalSite)

    return (
        <Elements stripe={reduxModalSite.stripePromise}>
            <TemplateBlock783StripeSite
                blockId={blockId}
                content={content}
                contentArray={contentArray ? (contentArray) : (content ? [content] : undefined)}
                formInfo={formInfo}
                formValue={formValue}
                isEditHovered={isEditHovered}
                isInComponent={isInComponent}
                learnPageSlug={learnPageSlug}
                mainParentId={mainParentId}
                object={object}
                pageSlug={pageSlug}
                parentArray={parentArray}
                parentStyles={parentStyles}
                setFormValue={setFormValue}
                styles={styles}
                stylesEdit={stylesEdit}
            />
        </Elements>
    )
})
